import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../utils/routes'
import SanferRedLabel from '../../baseComponents/SanferRedLabel'
import PageTitle from '../../baseComponents/PageTitle'
import Loader from '../../baseComponents/Loader'

import titleLogo from '../../assets/images/title-icons/Internet-Line.svg'

import { getPostBySlug } from '../../services/blog'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import './index.css'


const BlogPost = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]
    , slug = props.match.params.id

  const [isFetching, setIsFetching] = useState(true)
    , [data, setData] = useState(null)
    , [activeClass, setActiveClass] = useState('')

  useEffect(() => {
    let timeout = null
    setIsFetching(true)
    getPostBySlug(slug)
      .then(res => {
        setData(res)
        timeout = setTimeout(() => {
          setIsFetching(false)
          setActiveClass('active')
        }, 2000)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
  }, [slug])


  if (isFetching) return <Loader />

  let info = data[lang][0]
    , related = data[lang].related


  if (!info) return <MainLayout id='blog' className={`${activeClass} transition`} redLabel={false}>
    <SanferRedLabel />
    <PageTitle title={"Blog"} label={"comprometidos con tu salud"} logo={titleLogo} />

    <h1 style={{ textAlign: 'center', marginBottom: '20vh' }}>404</h1>


  </MainLayout>

  return <MainLayout id='blog' className={`blog__post ${activeClass} transition`} redLabel={false}>
    <div className='home__blog-featured'>
      <div className='home__blog-featured-cover' style={{ background: `url(${info.cover})` }} >
        <div className='decorative top' />
        <div className='decorative bottom' />
      </div>
    </div>
    <div className='blog__post-container'>
      <h1 className='blog__post-title'>{info.title}</h1>
      <p className='gray-color blog__post-extract'>{info.extract}</p>

      <div className='gray-color' dangerouslySetInnerHTML={{ __html: info.content }} />

      <div className="about-us__title-centered transition">
        <Link to={getURLByRouteName('post')} className="about-us__download-btn">
          {texts.blogBtn}
        </Link>
      </div>
    </div>
    <div className='blog__post-related'>
      {
        related instanceof Array &&
        related.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)
      }
    </div>
  </MainLayout>
}


const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(BlogPost)


const BlogItem = props => {
  const { texts } = props
  return <div className='home__blog-item'>
    <div className='home__blog-item-cover' style={{ background: `url(${props.cover})` }} />
    <div className='home__blog-item-desc'>
      <h2>{props.title}</h2>
      <Link to={`${getURLByRouteName('blog')}/${props.slug}`}>{texts.knowMore}</Link>
    </div>
  </div>
}